let HttpService = require('../services/http.service');

module.exports = {
  data() {
    return {
      loadingVisible: false,
      errorMessage: '',
    };
  },
  methods: {
    fetchResource: function(id, params, opts, callback) {
      var self = this;
      self.loadingVisible = true;
      HttpService.show(this.resource, id, params, function(response, err) {
        self[self.model] = response.result;
        self.loadingVisible = false;
        if (callback) {
          callback();
        }
      });
    },
    updateResource(id, params, opts, callback) {
      var self = this;

      if (!self.validate()) {
        return false;
      }

      let preventRedirect = opts && opts.preventRedirect ? (opts.preventRedirect == false) : true;

      self.loadingVisible = true;

      HttpService.update(self.resource, id, params, function(response, err) {

        if (err) {
          self.errorMessage = err.message;
          self.loadingVisible = false;
        } else if (preventRedirect) {
          self.$router.push({
            name: self.parentResource,
          });
        }
        else {
          self[self.model] = response.result;
          self.loadingVisible = false;
        }
      });
    },
    deleteResource(id) {
      var self = this;
      HttpService.remove(self.resource, id, function(response, err) {
        if (err) {
          self.errorMessage = err.message;
          self.loadingVisible = false;
          self.alertVisible = false;
        } else {
          self.confirmToggle();
          self.okVisible = true;
        }
      });
    },
    confirmToggle() {
      this.alertVisible = !this.alertVisible;
    },
    confirmAccept() {
      this.deleteResource(this[this.model].id);
    },
    okToggle() {
      this.okVisible = !this.okVisible;
      this.$router.push({
        name: this.parentResource,
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/editResource.mixin.js